import { PaRevision } from "../types/types"

export const getRecentDocumentsJson = {
  "dbRno": -1
}

export const getMyActivitiesJson = {
  "activityFilter": {
    "ActivityFilterType": "OpenActivities",
    "ActivityRecipientFilterType": "MyActivities",
    "RecipientName": "rec_id",
    "DocRno": 0,
    "RevRno": 0,
    "DueDays": 0
  }
}

export const getFolderDocumentsJson = {
	"folder": {
	  "FolderId": -1,
	  "FolderType": 1,
	  "HasChildren": false,
	  "CanViewResults": true,
	},
	"folderDocumentListArgs": {
		"IncludeVoidedDocuments": false
	}
}

export const saveOrDeleteFolderJson = {
	"folder": {
		"CanViewResults": true,
		"Count": 0,
		"FolderId":0,
		"FolderName": "folderName",
		"FolderType": "Favorites",
		"HasChildren":false,
		"IsInUse":false,
		"MaxCount":0,
		"ParentFolderId": 999,
		"ScriptRno":0 
	  }
}

export const AddDocumentsToFolderJson = {
	"folder": {
		"FolderId": 72701,
		"FolderType": 1,
		"HasChildren": false,
		"CanViewResults": true,
		"ResultListName": "Default View"
	  },
	  "docRnos": [1114832]
}

export const saveRevisionJson = {
	id:"",
	revision:{} ,
	saveProperties: {
	  FilesToCopy: [],
	  CopyFilesFromLatest: false
	}
  }

  export const saveNewRevisionJson = {
	id:"",
	revision:{} ,
	saveProperties: {
	  FilesToCopy: [],
	  CopyFilesFromLatest: false
	}
  }

  export const NewRevisionJson = {
	RevSeqno:-1,
	DocRno:-1,
	DbRno:-1,
	RevRno:-1,
	Rno:-1,
	RevisionCode: "",
	Status: "",
	MetaItems: [{Name: "STATUS", Value: "", HasMultipleValues: false}],
	TypeName:"SI.ProArc.WS.Revisions.Revision"
}

export const newWorkflow = {
    workflowMessage: {},
    documents: [],
    recipients: []
}

export const newWorkflowMessage= {
	workflowRno: -1,
	name: "",
	description: "",
	notes: "",
	workflowTemplateRno: -1,
	workflowClassRno: -1,
	plannedCloseDate: new Date().toISOString().substring(0,19),
	calendar: "STDNORSK",
	rfiMandatory: false,
	estimatedDays: 0,
	sentDate: new Date().toISOString().substring(0,10)+"T00:00:00",
	createdDate: new Date().toISOString().substring(0,10)+"T00:00:00"
}

export const startWfViaBlJson = {
	workflowItem: {
	  CreatedBy: "",
	  Sender: "",
	  CreatedDate: "0001-01-01T00:00:00",
	  SentDate: "0001-01-01T00:00:00",
	  ClosedDate: "0001-01-01T00:00:00",
	  ClosedBy: "",
	  PlannedCloseDate: "0001-01-01T00:00:00",
	  Status: 0,
	  WorkFlowPermissions: {
		CreateWorkflow: true
	  },
	  Id: -1,
	  Name: "",
	  Description: "",
	  Notes: "",
	  WorkflowTemplateId: -1,
	  WorkflowClassId: -1
	},
	workflowStartOptions: {
	  DocumentAccessValidated: true,
	  SelectedFilesForEmail: [],
	  StartDate: "0001-01-01T00:00:00"
	}
  }

export const startWfJson = {
	recipientEmails:[],
	startDate:"0001-01-01T00:00:00"
}

export const emptyRevJson:PaRevision = {
    $id: "-1",
	$ref: "-1",
    RevisionLog: [],
    RevSeqno: -1,
    StatusDate: "0001-01-01T00:00:00",
    DocRno: -1,
    DbRno: -1,
    FileCount: 0,
    Initiated: "0001-01-01T00:00:00",
    StatusBy: null,
    StatusTypeRno: -1,
    InitiatedBy: null,
    Created: "0001-01-01T00:00:00",
    CreatedBy: null,
    Status: "",
    RevRno: -1,
    Rno: -1,
    RevisionCode: "",
    Closed: false,
    MetaItems: [],
	Files: [],
    TypeName: "SI.ProArc.WS.Revisions.Revision"
}

export const getRevisionsJson = {
    "docRno": 0
  }

  export const searchFilesJson = {
    "query": {
      "Options": "Document",
      "MaxRows": 0,
      "QueryName": null,
      "Criteria": {
        "Items": [
             {"Name":"FI_FILENAME","Operator":0,"Value":"0000-PROENCO-O-0002_C_001.TXT","ItemType":0}
          ],
		"Criterias": [],
        "Operator": 0
      },
      "ReturnCountOnly": false
    }
}

export const documentSearchJson = {
    "query": {
      "ResultListName": null,
      "DbRnos": [2],
      "Presentation": null,
      "Options": "IncludeVoided",
      "MaxRows": 20,
      "QueryName": null,
      "Criteria": {
      "Items":[
            {"Name":"DOC_ID","Operator":1,"Value":"%proenco%","ItemType":0}
            ,{"Name":"TITLE","Operator":1,"Value":"test%","ItemType":0}
          ],
      "Criterias":[],
      "Operator":0
    },
      "ReturnCountOnly": false,
      "SearchDocumentsWithRights": "NoAccess"
    }
  }

  export const userSearchJson =  {
    "criteria": {
        "criterias": [
            {
                "criterias": [
                ],
                "items": [
                    {
                        "itemType": 0,
                        "name": "fullName",
                        "operator": 14,
                        "value": "{0}"
                    },
                    {
                        "itemType": 0,
                        "name": "userId",
                        "operator": 14,
                        "value": "{0}"
                    },
                    {
                        "itemType": 0,
                        "name": "eMail",
                        "operator": 14,
                        "value": "{0}"
                    }
                ],
                "operator": 1
            }
        ],
        "items": [
        ],
        "operator": 0
    },
    "noOfRecords": 100,
    "orderBy": [
        {
            "descendingOrder": false,
            "property": "fullName"
        }
    ],
    "pageNo": 1
}